/* ============================================================================
   BT-SLIDER-NAV.JS - geteilte Blaetter-Navigation fuer horizontale Slider
   ============================================================================
   Gehoert zu assets/bt-slider-nav.css. Sucht jedes Element mit data-bt-slider,
   findet darin den Track (data-bt-slider-track) und schaltet die Klassen
   has-prev und has-next, je nachdem ob in diese Richtung noch Inhalt kommt.
   Verlauf und Pfeil haengen allein an diesen Klassen, die Optik steckt im CSS.

   Absichtlich ohne Abhaengigkeiten und ohne Initialisierung im Markup, damit
   jeder kuenftige Slider nur die beiden data-Attribute setzen muss.
   ============================================================================ */
(function () {
  var TOL = 2; /* Toleranz in Pixeln, subpixel-Rundung von Browsern abfangen */

  function update(root, track) {
    var max = track.scrollWidth - track.clientWidth;
    var hasNext = max > TOL && track.scrollLeft < max - TOL;
    var hasPrev = track.scrollLeft > TOL;
    root.classList.toggle('has-next', hasNext);
    root.classList.toggle('has-prev', hasPrev);
  }

  function setup(root) {
    if (root.dataset.btSliderReady === '1') return;
    var track = root.querySelector('[data-bt-slider-track]');
    if (!track) return;
    root.dataset.btSliderReady = '1';

    var refresh = function () { update(root, track); };

    root.querySelectorAll('[data-bt-slider-go]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var back = btn.getAttribute('data-bt-slider-go') === 'prev';
        /* Vier Fuenftel der sichtbaren Breite, so bleibt beim Blaettern immer
           eine Karte als Anker stehen und der Nutzer verliert den Faden nicht. */
        var step = Math.max(Math.round(track.clientWidth * 0.8), 200);
        track.scrollBy({ left: back ? -step : step, behavior: 'smooth' });
      });
    });

    track.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);

    /* Bilder aendern die Trackbreite erst nach dem Laden, sonst stuende der
       Pfeil bei langsamer Verbindung faelschlich auf unsichtbar. */
    if (window.ResizeObserver) {
      new ResizeObserver(refresh).observe(track);
    } else {
      window.addEventListener('load', refresh);
    }

    refresh();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-bt-slider]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Im Theme-Editor werden Sections neu gerendert, ohne dass die Seite laedt. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
